import { useContext } from 'react';

import { ActiveLicenses } from './active-licenses.interface';
import { LicensesContext } from './licenses-context';

export const useLicense = <TActiveLicenses extends ActiveLicenses>(
  key: keyof TActiveLicenses & string,
): boolean => {
  const state = useContext(LicensesContext);

  if (!state) {
    throw new Error('useLicenses must be used within a LicenseConsumer');
  }

  return state.activeOnline?.[key] ?? state.defaults[key] ?? false;
};
